import { Link } from "react-router-dom";

const ImageTextOverlay = ({image, user}) => {
    return (  <div className="relative w-full h-[75vh] md:h-screen flex items-center justify-center text-center bg-black">
        <img
          src={image}
          alt="Music Background"
          className="absolute inset-0 w-full h-full object-cover opacity-40"
        />
        <div className="relative z-10 px-6">
          <h1 className="text-5xl font-bold text-yellow-400">
            Your Music, Your Audience
          </h1>
          <p className="text-lg text-gray-300 mt-3">
            Promote your music across all major streaming platforms.
          </p>
          <button className="mt-5 px-6 py-3 bg-yellow-500 text-black font-semibold rounded-lg hover:bg-yellow-400">
          {user? <Link to='/user/my-dashboard'>My Dashboard</Link>: <Link to='/sign-up'> Get Started</Link>}
          </button>
        </div>
      </div> );
}
 
export default ImageTextOverlay;